var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddbutton = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10.5,
  r: 10,
  fill: "#E1DFF2"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 10.5C5 10.1353 5.14486 9.78559 5.40273 9.52773C5.66059 9.26987 6.01033 9.125 6.375 9.125H9.125V6.375C9.125 6.01033 9.26986 5.66059 9.52773 5.40273C9.78559 5.14487 10.1353 5 10.5 5C10.8647 5 11.2144 5.14487 11.4723 5.40273C11.7301 5.66059 11.875 6.01033 11.875 6.375V9.125H14.625C14.9897 9.125 15.3394 9.26987 15.5973 9.52773C15.8551 9.78559 16 10.1353 16 10.5C16 10.8647 15.8551 11.2144 15.5973 11.4723C15.3394 11.7301 14.9897 11.875 14.625 11.875H11.875V14.625C11.875 14.9897 11.7301 15.3394 11.4723 15.5973C11.2144 15.8551 10.8647 16 10.5 16C10.1353 16 9.78559 15.8551 9.52773 15.5973C9.26986 15.3394 9.125 14.9897 9.125 14.625V11.875H6.375C6.01033 11.875 5.66059 11.7301 5.40273 11.4723C5.14486 11.2144 5 10.8647 5 10.5Z",
  fill: "#6B5CE8",
  stroke: "#E1DFF2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddbutton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addbutton.d474923d993da12f6723d3036e0c3728.svg";